import React, { Component } from 'react'
import {SelectDropdownStyle} from '../styles'
import {ArrowDrop} from '.'
import { css } from 'emotion'
import { ISOPHONE } from './../static/ISOPHONE'
import Flag from 'react-world-flags'

const Style = css({
  width: 100,
  'img': {
    width: 18,
  }
})

export default class SelectCountries extends Component {
  state = {
    open: false,
    value: '',
    isoCodeSelected: '',
    isoPhone: []
  }

  componentDidMount() {
    const nArr = []
    Object.keys(ISOPHONE).map(key => nArr[ISOPHONE[key].code.replace('+','')] = ({ code: key, country: ISOPHONE[key].name, phone: ISOPHONE[key].code }))
    this.setState({
      isoPhone: nArr
    })
  }

  handlerClick = () => {
    this.setState({ open: !this.state.open })
  }

  updateSelect = (select, key) => (e) => {
    e.preventDefault()
    this.setState({ value: select, open: !this.state.open, isoCodeSelected: key }, () => {
      this.props.callback(this.state.value)
    })
  }

  render () {
    const { label, children } = this.props
    const { open, value, isoCodeSelected, isoPhone } = this.state
    return (
      <div className={`${SelectDropdownStyle(open, value)} dropdown ${Style} required-indicator`}>
        <div className="dropdown-label" onClick={this.handlerClick}> 
          {isoCodeSelected !== '' && <Flag code={isoCodeSelected} />}
          {value === '' ? children : value} <ArrowDrop width={16} height={16} />
        </div>
        <ul className="reset dropdown-list">
          {isoPhone.map(item => (
            <li key={item.code} onClick={this.updateSelect(item.phone, item.code)} className={value === item.phone ? 'active' : ''}>
              <Flag code={item.code} /> { item.phone }
            </li>
            ))
          }
        </ul>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/SelectPhone.js